import React, { useEffect, useState } from 'react';

import * as api from 'api/methods';

import LessonCatalogCategoryField from './LessonCatalogCategoryField';

const CATEGORIES_FETCH_LIMIT = 500;

const LessonCatalogCategoryFieldContainer = ({
  className,
  labelClassName,
  lessonRole,
  readOnly,
}: {
  className?: string;
  labelClassName?: string;
  lessonRole: any;
  readOnly: any;
}) => {
  const [options, setOptions] = useState<{ label: string; value: string }[]>(
    [],
  );
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (lessonRole !== 'CATALOG') {
      setLoading(false);

      return;
    }

    const loadCategories = async () => {
      try {
        const res = await api.getLessonCategories({
          page: 1,
          limit: CATEGORIES_FETCH_LIMIT,
          sortBy: 'name',
          sortDirection: 'asc',
        });

        const list = Array.isArray(res) ? res : res?.data ?? [];

        setOptions(
          list.map((c: any) => ({
            label: c.name ?? c.id,
            value: c.id,
          })),
        );
      } catch (error) {
        console.warn(error);
        setOptions([]);
      } finally {
        setLoading(false);
      }
    };

    loadCategories();
  }, [lessonRole]);

  return (
    <LessonCatalogCategoryField
      className={className}
      labelClassName={labelClassName}
      lessonRole={lessonRole}
      readOnly={readOnly}
      options={options}
      loading={loading}
    />
  );
};

export default React.memo(LessonCatalogCategoryFieldContainer) as any;
